import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcademyCommonModule, PipesModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { BookingErrorComponent } from './booking-error.component';

const routes: Routes = [{ path: 'booking-error', component: BookingErrorComponent }];

@NgModule({
    declarations: [BookingErrorComponent],
    providers: [],
    imports: [
        CommonModule,
        AcademyCommonModule,
        PipesModule,
        AcademyPresentationUiModule,
        TranslateModule.forChild(),
        RouterModule.forChild(routes),
        LocalizeRouterModule.forChild(routes)
    ]
})
export class BookingErrorModule {}
